/**
 * Decide se um 401 vindo de um cliente axios INTERNO deve redirecionar o
 * usuário pro `/login` interno.
 *
 * Regra (defesa de fronteira interno × portal):
 * - NÃO redireciona se já estamos numa página de login interna (`/login*`),
 *   senão entra em loop de redirect num login que falha.
 * - NÃO redireciona se estamos em QUALQUER rota do Portal do Parceiro
 *   (`/portal/*`). O portal tem auth própria (`portalApi` → `/portal/login`);
 *   se um hook/cliente INTERNO vazar numa página do portal e tomar 401, ele
 *   não pode sequestrar a navegação pro login interno — o parceiro nem tem
 *   conta interna. (Bug 2026-06-17: `useSectionTelemetry` na AtendimentoPage
 *   do portal disparava POST interno → 401 → bounce pro `/login`.)
 * - NÃO redireciona em `/primeiro-acesso` (biometria facial, evento 25/09/2026).
 *   Mesma classe do caso acima: quem está nessa tela AINDA NÃO TEM como passar
 *   pelo login interno — é exatamente o que veio resolver ali. As chamadas da
 *   própria tela usam um axios sem este interceptor, mas os providers do App
 *   (Auth, Notification, Presence) montam FORA de `<Routes>` e rodam nela
 *   também; um 401 de qualquer um deles sequestraria a navegação no meio do
 *   cadastro, e a pessoa cairia num login que ela não consegue passar.
 *
 * Mantida como função pura (recebe o pathname) pra ser unit-testável sem
 * mexer em `window.location`.
 */
export function shouldBounceToInternalLogin(pathname: string): boolean {
  if (pathname.includes("/login")) return false;
  if (pathname.startsWith("/portal")) return false;
  if (pathname.startsWith("/primeiro-acesso")) return false;
  return true;
}
